import { render, staticRenderFns } from "./Mahnungen.vue?vue&type=template&id=518c285e"
import script from "./Mahnungen.vue?vue&type=script&lang=js"
export * from "./Mahnungen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports